import { LAYOUT_VIEW_ENUM } from '../constant/index'

export default {
  state: {
    layoutView: LAYOUT_VIEW_ENUM.LRR,
    showSubmitBtn: false,
    showCloseBtn: false,
  },
  getters: {
    layoutView: ({ layoutView }) => layoutView,
    showSubmitBtn: ({ showSubmitBtn }) => showSubmitBtn,
    showCloseBtn: ({ showCloseBtn }) => showCloseBtn,
  },
  actions: {
  },
  mutations: {
    setLayoutView (state, val) {
      state.layoutView = val
    },
    setShowSubmitBtn (state, val) {
      state.showSubmitBtn = val
    },
    setShowCloseBtn (state, val) {
      state.showCloseBtn = val
    },
  }
}
